import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IHomeWorkServiceResponse } from 'src/app/shared/models/homework.model';
import { HomeworkService } from 'src/app/shared/services/homework.service';

@Component({
  selector: 'app-homework',
  templateUrl: './homework-detail.component.html',
})
export class HomeworkDetailComponent implements OnInit {
  homework ?: IHomeWorkServiceResponse;
  constructor(
    private activatedRoute: ActivatedRoute,
    private homeworkService: HomeworkService
  ) { }
  ngOnInit(): void {
    const currentId = this.activatedRoute.snapshot.paramMap.get('id')
    if(currentId){
      this.homeworkService.getHomeworkDetail(currentId)
      .subscribe((res)=>{
        this.homework = res;
      })
    }
  }

}
